import { apiUrl, googleApiKey } from "../constants/common";
import { axiosInstance } from "./axiosInstance";

const emailExists = (email) => {
  return axiosInstance.get('email/exists', { params: { email } });
}

const verifyUser = (email) => {
  return axiosInstance.get('unsubscribe-email/verify', { params: { ...email } });
}

const unsubscribeEmail = (email) => {
  return axiosInstance.post('unsubscribe-email/track', { ...email });
}

const unsubscribeAllEmails = (email) => {
  return axiosInstance.post('unsubscribe-email/unsubscribe-all', { ...email });
}

const getReleaseVersion = () => {
  return axiosInstance.get('meta/release');
}

const getStatesList = () => {
  return axiosInstance.get('states');
}

const getZipcodesList = (data) => {
  return axiosInstance.get('zipcodes', { params: data || {} });
}

const getDegreesList = () => {
  return axiosInstance.get('degrees');
}

const getLicensesList = () => {
  return axiosInstance.get('license');
}

const getCertificatesList = () => {
  return axiosInstance.get('certificate');
}

const getClientTypesList = () => {
  return axiosInstance.get('client-types');
}

const sendFeedback = (data) => {
  return axiosInstance.post('feedback', data);
}

const uploadImage = (data) => {
  const formData = new FormData();
  formData.append('file', data);
  return axiosInstance.post('attachments/upload-image', formData);
}

const uploadFile = (data) => {
  const formData = new FormData();
  formData.append('file', data);
  return axiosInstance.post('attachments/upload-file', formData);
}

const deleteAttachments = (data) => {
  return axiosInstance.delete('attachments/delete', { params: data });
}


const getTratmentProgramConstants = (type) => {
  return axiosInstance.get(`treatment-program-constants/${type}`);
}

const getCities = (data) => {
  return axiosInstance.get('cities', { params: data || {} });
}

const geocodeAddress = async (address) => {
  try {
    const response = await fetch(
      `${apiUrl}google-geocode?address=${encodeURIComponent(
        address
      )}`
    );

    const data = await response.json();

    if (data.status === "OK" && data.results.length > 0) {
      const place = data.results[0];
      let city = "",
        state = "",
        zipCode = "";

      for (let comp of place.address_components) {
        if (comp.types.includes("locality")) city = comp.long_name;
        if (comp.types.includes("administrative_area_level_1"))
          state = comp.long_name;
        if (comp.types.includes("postal_code")) zipCode = comp.long_name;
      }

      const selectedAddress = {
        location: place.formatted_address,
        lat: place.geometry.location.lat,
        lng: place.geometry.location.lng,
        city,
        zipCode,
        state,
      };

      return selectedAddress;
    }
  } catch (error) {
    console.error("Geocoding failed", error);
  }
};

export {
  emailExists,
  verifyUser,
  unsubscribeEmail,
  unsubscribeAllEmails,
  getStatesList,
  geocodeAddress,
  getDegreesList,
  getLicensesList,
  getCertificatesList,
  getClientTypesList,
  sendFeedback,
  uploadImage,
  uploadFile,
  getTratmentProgramConstants,
  deleteAttachments,
  getCities,
  getZipcodesList,
  getReleaseVersion
}